import React, { useState, useMemo } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "components/common/Box";
import Text from "components/common/Text";
import { withRouter } from "react-router";
import MenuItem from "components/common/MenuItem";
import Select from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import Button from "components/common/Button";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import CTable from "components/common/Table";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Stack from "components/common/Stack";
import Switch from "components/common/Switch";
import { useFormik } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import * as yup from "yup";

const FaqCategories = ({
  handleClickOpenStatus,
  handleClickOpen,
  handleClickOpenModel,
  loading,
  data,
  onSubmit,
  parentCategory,
  handleCategoriChange,
  handleDeleteOpenModel,
  getCategoriesList,
  getFaqParentCategories,
  handlePageTypeChange,
}) => {
  let pageTypes = [
    {
      name: "Ev Website",
      id: "EVJOINTS_WEBSITE",
    },
    {
      name: "Ev APP",
      id: "EVJOINTS_APP",
    },
    
  ];
  let history = useHistory();
  const classes = useStyles();
  const [inputVisible, setInputVisible] = useState(false);
  const [addCategoryType, setAddCategoryType] = useState("category");
  const [tabValue, setTabValue] = useState("category");

  const [inputText, setInputText] = useState("");
  const [inputText1, setInputText1] = useState("");
  const filteredData = useMemo(() => {
    if (!inputText) {
      return parentCategory;
    }

    const lowerCaseInputText = inputText.toLowerCase();

    return parentCategory.filter((item) => {
      const { name } = item;

      const lowerCaseName = name.toLowerCase();

      return lowerCaseName.includes(lowerCaseInputText);
    });
  }, [parentCategory, inputText]);

  const filteredData1 = useMemo(() => {
    if (!inputText1) {
      return data;
    }

    const lowerCaseInputText = inputText1.toLowerCase();

    return data.filter((item) => {
      const { name } = item;

      const lowerCaseName = name.toLowerCase();

      return lowerCaseName.includes(lowerCaseInputText);
    });
  }, [data, inputText1]);

  let inputSearchHandler = (e) => {
    const lowerCase = e.toLowerCase();
    setInputText(lowerCase);
  };

  let inputSearchHandler1 = (e) => {
    const lowerCase = e.toLowerCase();
    setInputText1(lowerCase);
  };

  const handleTabChange = async (value) => {
    await getCategoriesList();
    await getFaqParentCategories({
      parent_id: 0,
      //  pagetype:pagetype
    });
    setTabValue(value);
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      valueGetter: (v, d) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {d.name}
          </Box>
        );
      },
    },
    {
      field: "Action",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Tooltip title="Edit">
              <IconButton aria-label="edit" onClick={() => handleClickOpen(d)}>
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={d.status === 1 ? "Deactivate" : "Activate"}>
              <IconButton
                aria-label="status"
                onClick={() => handleClickOpenStatus(d.id, d.status ? 0 : 1)}
              >
                <Switch checked={d.status === 1} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => handleDeleteOpenModel(d.id)}
                sx={{ cursor: "pointer" }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  const columns_sub = [
    {
      field: "name",
      headerName: "Sub category",
    },
    {
      field: "name",
      headerName: "Category",
      valueGetter: (v, d) => {
        return d.parentCategory?.name || "N/A";
      },
    },
    {
      field: "Action",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Tooltip title="Edit">
              <IconButton aria-label="edit" onClick={() => handleClickOpen(d)}>
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={d.status === 1 ? "Deactivate" : "Activate"}>
              <IconButton
                aria-label="status"
                onClick={() => handleClickOpenStatus(d.id, d.status ? 0 : 1)}
              >
                <Switch checked={d.status === 1} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => handleDeleteOpenModel(d.id)}
                sx={{ cursor: "pointer" }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  const validateLoginForm = yup.object().shape({
    category_id: yup.string().required("Category is Required"),
    parent_id:
      addCategoryType === "sub-category"
        ? yup.string().required("Sub Category is Required")
        : yup.string().nullable(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnSubmit: true,
    initialValues: {
      category_id: "",
      parent_id: null,
      content_type:""
    },

    onSubmit: (values) => {
      onSubmit(values);
      setInputVisible(false);
      formik.resetForm();
    },

    validationSchema: validateLoginForm,
  });

  return (
    <>
      <Text
        variant="h5"
        color="#707070"
        sx={{
          fontSize: "24px",
          marginTop: "-2px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <ArrowBackIcon
          sx={{
            fontSize: "24px",
            fontWeight: "bold",
            marginRight: "10px",
            cursor: "pointer",
          }}
          onClick={() => history.goBack()}
        />
        Category
      </Text>

      {inputVisible ? (
        <form onSubmit={formik.handleSubmit}>
          <Stack direction="column" spacing={2}>
            <IconButton
              onClick={() => setInputVisible(!inputVisible)}
              sx={{ alignSelf: "flex-end" }}
            >
              <CloseIcon />
            </IconButton>
            <FormControl>
              <FormLabel>Type</FormLabel>
              <RadioGroup
                row
                aria-label="category-type"
                name="category-type"
                value={addCategoryType}
                onChange={(e) => setAddCategoryType(e.target.value)}
              >
                <FormControlLabel
                  value="category"
                  control={<Radio />}
                  label="Category"
                />
                <FormControlLabel
                  value="sub-category"
                  control={<Radio />}
                  label="Sub Category"
                />
              </RadioGroup>
            </FormControl>

            {addCategoryType === "category" ? (
              <FormControl fullWidth size="small">
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  id="category_id"
                  label="Enter category name"
                  {...formik.getFieldProps("category_id")}
                  error={
                    formik.touched.category_id &&
                    Boolean(formik.errors.category_id)
                  }
                  helperText={
                    formik.touched.category_id && formik.errors.category_id
                  }
                />
                
                <FormControl sx={{marginTop:"20px"}}>
                  <InputLabel
                    sx={{ fontSize: "16px", marginTop: "-3px" }}
                    id="pagetype"
                  >
                    Select Page Type 
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "16px" }}
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Select pagetype"
                    id="content_type"
                    labelId="content_type"
                    value={formik.values.content_type}
                    onChange={formik.handleChange("content_type")}
                    onBlur={formik.handleBlur("content_type")}
                    error={
                      formik.touched.content_type && Boolean(formik.errors.content_type)
                    }
                    helperText={
                      formik.touched.content_type && formik.errors.content_type
                    }
                  >
                    {pageTypes?.map((item) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={item.id}
                        value={item.id}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </FormControl>
            ) : (
              <>
                <FormControl fullWidth size="small">
                  <TextField
                    InputLabelProps={{ style: { fontSize: "16px" } }}
                    fullWidth
                    size="small"
                    label="Category Name"
                    {...formik.getFieldProps("category_id")}
                    error={
                      formik.touched.category_id &&
                      Boolean(formik.errors.category_id)
                    }
                    helperText={
                      formik.touched.category_id && formik.errors.category_id
                    }
                  />
                    <FormControl sx={{marginTop:'20px'}}>
                <InputLabel id="select-category-label"   sx={{ fontSize: "16px", marginTop: "-3px" }}>
                  Select Page Type
                </InputLabel>

                <Select
                  fullWidth
                  size="small"
                  id="parent_id"
                  labelId="select-category-label"
                  sx={{ fontSize: "16px",padding:'4px' }}
                  label=" Select Page Type"
                  onChange={(e) => {
                    const value = e.target.value;
                    handlePageTypeChange(value);
                    formik.setFieldValue('content_type', value);
                }}
                  defaultValue={"all"}
                >
                  <MenuItem sx={{ fontSize: "12px" }} key="all" value="all">
                    All
                  </MenuItem>
                  {pageTypes?.map((item) => (
                    <MenuItem
                      sx={{ fontSize: "14px" }}
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
                </FormControl>

                <FormControl>
                  <InputLabel
                    sx={{ fontSize: "16px", marginTop: "-3px" }}
                    id="parent_id"
                  >
                    Select Category 
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "16px" }}
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Select Category"
                    id="parent_id"
                    labelId="parent_id"
                    value={formik.values.parent_id}
                    onChange={formik.handleChange("parent_id")}
                    onBlur={formik.handleBlur("parent_id")}
                    error={
                      formik.touched.parent_id &&
                      Boolean(formik.errors.parent_id)
                    }
                    helperText={
                      formik.touched.parent_id && formik.errors.parent_id
                    }
                  >
                    {parentCategory?.map((item) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={item.id}
                        value={item.id}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}

            <Button
              type="submit"
              disableElevation
              variant="contained"
              loading={loading}
              disabled={
                addCategoryType === "category"
                  ? formik.values.category_id === ""
                  : formik.values.category_id === "" ||
                    formik.values.parent_id === null
              }
              onClick={() => handleClickOpenModel()}
            >
              Save
            </Button>
          </Stack>
        </form>
      ) : (
        <Stack direction="row" alignItems="flex-end" justifyContent="flex-end">
          <Button
            onClick={() => setInputVisible(!inputVisible)}
            size="small"
            disableElevation
            variant="contained"
            sx={{
              borderRadius: "50px",
              marginRight: "1rem",
              color: "white",
              width: "200px",
            }}
          >
            + Add
          </Button>
        </Stack>
      )}

      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={(e, newValue) => handleTabChange(newValue)}>
            <Tab label="Category" value="category" />
            <Tab label="Subcategory" value="subcategory" />
          </TabList>
        </Box>
        <TabPanel value="category">
          <FormControl sx={{position:"relative",top:'40px'}}>
            <InputLabel id="select-category-label">Select Page Type </InputLabel>

            <Select
              fullWidth
              size="small"
              id="parent_id"
              labelId="select-category-label"
              sx={{ width: "200px", fontSize: "14px" }}
              label=" Select Page Type ......."
              onChange={(e) => handlePageTypeChange(e.target.value)}
              defaultValue={"all"}
            >
              <MenuItem sx={{ fontSize: "14px" }} key="all" value="all">
                All
              </MenuItem>
              {pageTypes?.map((item) => (
                <MenuItem
                  sx={{ fontSize: "14px" }}
                  key={item.id}
                  value={item.id}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Stack direction="row" alignItems="center" justifyContent="flex-end">
            <Box sx={{ textAlign: "right" }}>
              <Paper
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "250px",
                  boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                  borderRadius: "5px",
                  padding: "5px",
                  backgroundColor: "#fff",
                  marginRight: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  onChange={(e) => inputSearchHandler(e.target.value)}
                  inputProps={{ "aria-label": "search" }}
                />
              </Paper>
            </Box>
          </Stack>
          <CTable
            columns={columns}
            data={filteredData}
            isLoading={loading?.isLoading}
            pagination={true}
            localPagination={true}
            page={0}
            rowsPerPage={5}
          />
        </TabPanel>
        <TabPanel value="subcategory">
          <Stack direction="row" justifyContent="space-between">
            <div>
              <FormControl sx={{marginRight:"10px"}}>
                <InputLabel id="select-category-label">
                  Select Page Type 
                </InputLabel>

                <Select
                  fullWidth
                  size="small"
                  id="parent_id"
                  labelId="select-category-label"
                  sx={{ width: "200px", fontSize: "14px" }}
                  label=" Select Page Type ......."
                  onChange={(e) => handlePageTypeChange(e.target.value)}
                  defaultValue={"all"}
                >
                  <MenuItem sx={{ fontSize: "14px" }} key="all" value="all">
                    All
                  </MenuItem>
                  {pageTypes?.map((item) => (
                    <MenuItem
                      sx={{ fontSize: "14px" }}
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <InputLabel id="select-category-label">
                  Select Category
                </InputLabel>

                <Select
                  fullWidth
                  size="small"
                  id="parent_id"
                  labelId="select-category-label"
                  sx={{ width: "200px", fontSize: "14px" }}
                  label="Select Category......."
                  onChange={(e) => handleCategoriChange(e.target.value)}
                  defaultValue={"all"}
                >
                  <MenuItem sx={{ fontSize: "14px" }} key="all" value="all">
                    All
                  </MenuItem>
                  {parentCategory?.map((item) => (
                    <MenuItem
                      sx={{ fontSize: "14px" }}
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <Box className={classes.searchBox}>
              <Paper
                sx={{
                  p: "2.5px 0",
                  display: "flex",
                  alignItems: "flex-end",
                  width: "250px",
                  marginBottom: "20px",
                  boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  onChange={(e) => inputSearchHandler1(e.target.value)}
                  inputProps={{ "aria-label": "search" }}
                />
              </Paper>
            </Box>
          </Stack>

          <CTable
            columns={columns_sub}
            data={filteredData1}
            isLoading={loading?.isLoading}
            pagination={true}
            localPagination={true}
            page={0}
            rowsPerPage={5}
          />
        </TabPanel>
      </TabContext>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  searchBox: {
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    "@media (max-width:768px)": {
      float: "none",
    },
  },
}));

export default withRouter(FaqCategories);
